<template>
  <div class="classify">
    <div ref="head">
      <div class="tap-bar">
        <div :class="['tap', tap !== 0 || 'pitchOn']" @click="$router.push('/monthly')"><span>总汇总</span></div>
        <div :class="['tap', tap !== 1 || 'pitchOn']" @click="$router.push('/monthly-detail')"><span>分月明细</span></div>
        <div :class="['tap', tap !== 2 || 'pitchOn']" @click="$router.push('/classify')"><span>分类汇总</span></div>
      </div>
    </div>
    <div class="seek">
      <div class="date-box" @click="show = true">
        <van-icon name="clock-o"/>
        <span class="time">{{date1}}</span>
      </div>
      <p>单位：千元</p>
    </div>
    <div class="content-s" ref="tableContent">
      <div :key="index" class="div" v-for="(item,index) of dataList">
        <p>{{item.title}}</p>
        <table-tap
          :data="item.list"
          :header="header"
          :height="winDowWidth > 375 ? winDowWidth / 414 * 155 : winDowWidth / 375 * 144"
          :width="table.width"
        >
        </table-tap>
      </div>
    </div>
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '280px' }"
    >
      <van-datetime-picker
        v-model="date"
        type="year-month"
        @confirm="confirmOk"
        @cancel="show = false"
        :formatter="formatter"
      />
    </van-popup>
  </div>
</template>

<script>
  import tableTap from './../../components/table/tab-section'
  import {monthly} from '../../api/v1'
  import {getTimes, upOfDown} from '../../utils'

  export default {
    name: "classify",
    data() {
      return {
        tap: 2,
        monthlyTime: '',
        monthlyList: '',
        table: {
          header: [],
          data: [],
          width: 0,
          height: 500
        },
        date: null,
        show: false,
        winDowWidth: window.screen.width,
        date1: '',
        dataList: []
      }
    },
    created() {
      this.date = new Date(getTimes('Y-M'))
      this.date1 = getTimes('Y-M')
      this.getAllList()
    },
    methods: {
      getAllList() {
        monthly.getMonthlyList({
          total_month: getTimes('YM', this.date1),
          data_type: '分类汇总'
        }).then(res => {
          if (res.code === 200) {
            this.monthlyList = res.data
            this.cutTap(this.tap)
          }
        })
      },
      cutTap(v) {
        this.getTableContentSize()
        this.tap = v
        let list = this.monthlyList
        let dataList = list.data
        let da = []
        switch (v) {
          case 2:
            Object.keys(dataList).map(item => {
              if (item !== 'columns') {
                da.push({
                  title: item,
                  list: dataList[item]
                })
              }
            })
            this.dataList = da
            this.header = list.columns.map(item => {
              let obj = {
                title: item,
                key: item,
                width: 100
              }
              if (item.includes('同比增长')) {
                obj.render = (h, p) => {
                  let text = p.row[item]
                  return h('div', {class: 'td-down-of-up'}, [
                    h('span', text),
                    h('i', {class: upOfDown(text)})
                  ])
                }
              }
              let fixed = ['(000 RMB)']
              if (fixed.includes(item)) {
                obj.fixed = 'left'
              }
              return obj
            })
            break
        }
      },
      getTableContentSize() {
        this.table.width = this.$refs.tableContent.offsetWidth
      },
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`;
        } else if (type === 'month') {
          return `${value}月`
        }
        return value;
      },
      confirmOk(e) {
        this.date = e
        this.date1 = getTimes('Y-M', e)
        this.show = false
        this.getAllList()
      }
    },
    components: {
      tableTap
    },
    mounted() {
      this.$nextTick(() => {
        this.getTableContentSize()
      })
    },
    computed: {
      getHeight() {
        return list => {
          if (list && list.length) {
            return list.length > 10 ? 200 : parseInt(list.length * 32 + 60)
          } else return 0
        }
      }
    },
    beforeDestroy() {
    }
  }
</script>

<style lang="scss" scoped>
  .classify {
    overflow: hidden;
    width: 100%;
    height: 100%;

    .tap-bar {
      padding: 10px 10px 0;
      display: flex;

      .tap {
        width: 97px;
        height: 27px;
        background: url('~@/assets/imgs/tap15@2x.png') no-repeat;
        background-size: 100% 100%;
        font-size: 15px;
        color: #fff;
        text-align: center;
        line-height: 27px;
        padding-right: 10px;

        &.pitchOn {
          background: url('~@/assets/imgs/onTap15@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .content-s {
      margin: 10px;

      .div {
        width: calc(100vh - 20px);
        margin-bottom: 30px;

        p {
          margin-top: 10px;
          color: #fff;
        }
      }
    }
  }
</style>
